import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-divider',
  templateUrl: './ticket-graphic-divider.component.html',
  styleUrls: ['./ticket-graphic-divider.component.scss'],
})
export class TicketGraphicDividerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
